/**
 * Inline icons of the light login form (no icon library on the auth pages).
 */

import type { ReactElement, ReactNode } from "react";

function StrokeIcon({
  size,
  strokeWidth = "1.9",
  children,
}: {
  readonly size: number;
  readonly strokeWidth?: string;
  readonly children: ReactNode;
}): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function MailIcon(): ReactElement {
  return (
    <StrokeIcon size={17}>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </StrokeIcon>
  );
}

export function LockIcon(): ReactElement {
  return (
    <StrokeIcon size={17}>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </StrokeIcon>
  );
}

export function EyeOffIcon(): ReactElement {
  return (
    <StrokeIcon size={18}>
      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
      <line x1="2" x2="22" y1="2" y2="22" />
    </StrokeIcon>
  );
}

export function EyeIcon(): ReactElement {
  return (
    <StrokeIcon size={18}>
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </StrokeIcon>
  );
}

export function ArrowRightIcon(): ReactElement {
  return (
    <StrokeIcon size={17} strokeWidth="2.2">
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </StrokeIcon>
  );
}

/** „← Zur Website“ arrow. */
export function ArrowLeftIcon(): ReactElement {
  return (
    <StrokeIcon size={15}>
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </StrokeIcon>
  );
}

export function Spinner(): ReactElement {
  return (
    <svg
      className="mklogin-spinner"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <circle
        cx="8"
        cy="8"
        r="6"
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.35"
        strokeWidth="1.6"
      />
      <path
        d="M8 2 a 6 6 0 0 1 6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
